import { Component, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SignupComponent } from '../signup/signup.component';
import { TranslatePipe } from '../../i18n/translate.pipe';

@Component({
    selector: 'app-signinbox',
    templateUrl: './signinbox.component.html',
    styleUrls: ['./signinbox.component.css'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, TranslatePipe]
})
export class SigninBoxComponent {

  email = '';
  password = '';
  loggedIn = true;
  isDevMode = isDevMode();

  constructor(public authService: AuthService,
    public dialog: MatDialog, private router: Router) {
    // Subscribe to auth state changes to update UI
    this.authService.authStateChanged.subscribe(() => {
      // Angular change detection will automatically update the UI
      // when authService.isLoggedIn() is called in the template
    });
  }

  onAuthenticate() {
    // Zapamiętaj bieżącą stronę, żeby po zalogowaniu wrócić dokładnie na nią.
    // Nadpisanie załatwia też porzucony redirect z przepływu wygaśnięcia
    // sesji. Ze strony głównej i ekranu logowania obowiązuje domyślne
    // przekierowanie na drzewo użytkownika.
    const currentUrl = this.router.url;
    if (currentUrl && currentUrl !== '/' && !currentUrl.startsWith('/signin')) {
      this.authService.setRedirectUrl(currentUrl);
    } else {
      this.authService.clearRedirectUrl();
    }
    this.router.navigate(['/signin']);
  }

  onRegister() {
    this.dialog.open(SignupComponent, {
      data: {
        inDialog: true,
      },
      disableClose: true,
      autoFocus: false,
      width: '400px',
      maxWidth: '95vw',
    });
  }

  onLogout() {
    this.authService.logout();
  }

}
